import { BasePage } from 'src/app/@shared/base.page';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalOptions } from '@ionic/angular';

@Injectable()
export abstract class BaseDetailPage<T extends { id: string }> extends BasePage<T> {
  public item: Partial<T> = {};

  public ngOnInit(): void {
    const state = this.getNavigationState();

    if (state?.item && state.item?.id) {
      this.currentContentId = state.item.id;
      this.viewStates[this.currentContentId] = this.getInitialViewStates(true);
      this.item = state.item;
    } else {
      this.currentContentId = this.activatedRoute.snapshot.params.id || this.constructor.name;
      this.viewStates[this.currentContentId] = this.getInitialViewStates(false);
    }

    this.setCurrenTabUrl();
    this.protoOnInit();
  }

  public navigateBack(): Promise<boolean> {
    return this.navController.navigateBack(['../'], {
      relativeTo: this.activatedRoute,
    });
  }

  protected onRequestSucceeded(id: string): void {
    this.viewStates[id].hasError = false;
    this.viewStates[id].isEmpty = false;

    this.onRequestFinished(id);
  }

  protected onRequestFailed(id: string, error: Partial<HttpErrorResponse>): void {
    if (this.isCanceledRequest(error)) {
      this.viewStates[id].hasError = false;
      this.onRequestFinished(id);

      return;
    }

    const errorResponse = error || {
      message: 'unexpected null value',
    };

    console.error(errorResponse.message);

    // remove skeleton data
    if (this.viewStates[id].showSkeleton) {
      this.item = {
        id: this.item?.id,
      } as unknown as Partial<T>;
    }

    this.viewStates[id].hasError = true;

    this.onRequestFinished(id);
  }

  protected async openModal(modalOptions: ModalOptions): Promise<{data: unknown; role: string}> {
    const topModal = await this.modalController.getTop();

    modalOptions.presentingElement = topModal || document.querySelector('ion-router-outlet');
    modalOptions.backdropDismiss = false; // prevent backdrop click to close modal (customer request)

    const modal = await this.modalController.create(modalOptions);

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    return Promise.resolve({
      data,
      role,
    });
  }
}
